module.exports = __webpack_public_path__ + "img/mf-finalist-logo-2024-broker-rgb.d3c2eea6.png";